import { InteractionRequiredAuthError } from '@azure/msal-browser';
import axios from 'axios';
import {
  backendRequest,
  loginRequest,
  msalInstance,
} from '../../shared/authentication-config';

export const principalServiceRequest = async <T>(
  method: string,
  urlExtension: string,
  body?: Record<string, unknown> | FormData,
  params?: Record<string, unknown>,
) => {
  const token = await getEntraIdToken();
  if (!token) {
    return Promise.reject(new Error('No valid token found'));
  }
  return axios<T>({
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${process.env.REACT_APP_PORTAL_SERVICE_BASE_URL}/${urlExtension}`,
    method,
    data: body,
    params,
  });
};

const getEntraIdToken = async () => {
  const account = msalInstance.getActiveAccount();
  if (!account) {
    return msalInstance.loginRedirect(loginRequest);
  }
  try {
    const { accessToken } = await msalInstance.acquireTokenSilent(
      backendRequest,
    );

    return accessToken;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      return msalInstance.acquireTokenRedirect({ ...backendRequest, account });
    }
    return null;
  }
};
